/* Scroll poses are deterministic: scrolling backwards retraces the same scene. */
(function(root,factory){const api=factory();if(typeof module==='object'&&module.exports)module.exports=api;else root.TakeBagOfficialJourney=api;})(typeof window==='object'?window:this,function(){
  const clamp=(v,a=0,b=1)=>Math.min(b,Math.max(a,v));
  const mix=(a,b,t)=>a+(b-a)*t;
  const ease=t=>t*t*(3-2*t);
  function pose(progress,width,height,narrow){
    const p=clamp(progress),base=narrow?Math.min(310,height*.44):Math.min(480,width*.38,height*.82);
    const frames=narrow?[
      [0,.50,.63,1,-11,1,.79,.69,.75,-18,0],
      [.18,.29,.65,.94,-9,1,.76,.69,.752,-8,0],
      [.30,.43,.65,.94,0,1,.76,.69,.752,-8,0],
      [.45,.43,.65,.94,0,1,.76,.69,.752,-8,0],
      [.58,.43,.65,.94,0,1,.76,.65,.752,0,1],
      [.68,.43,.65,.94,0,1,.76,.65,.752,0,1],
      [.84,.35,.62,.94,-5,1,.68,.62,.752,5,1],
      [1,.35,.62,.94,-3,1,.68,.62,.752,3,1]
    ]:[
      [0,.72,.50,1,-11,1,.87,.65,.75,-18,0],
      [.18,.60,.52,.96,-9,1,.87,.59,.768,-8,0],
      [.30,.69,.52,.96,0,1,.87,.59,.768,-8,0],
      [.45,.69,.52,.96,0,1,.87,.59,.768,-8,0],
      [.58,.69,.52,.96,0,1,.87,.52,.768,0,1],
      [.68,.69,.52,.96,0,1,.87,.52,.768,0,1],
      [.84,.65,.52,.90,-5,1,.83,.52,.72,5,1],
      [1,.65,.52,.90,-3,1,.83,.52,.72,3,1]
    ];
    let i=0;while(i<frames.length-2&&p>frames[i+1][0])i++;
    const a=frames[i],b=frames[i+1],t=ease(clamp((p-a[0])/(b[0]-a[0])));
    const v=a.map((n,j)=>mix(n,b[j],t));
    const bag={x:v[1]*width,y:v[2]*height,size:v[3]*base,angle:v[4],opacity:v[5]};
    const bottle={x:v[6]*width,y:v[7]*height,size:v[8]*base,angle:v[9],opacity:v[10]};
    const join=ease(clamp((p-.70)/.14));
    bottle.y=mix(bottle.y,bag.y+bag.size*.40-bottle.size*.375,join);
    const chapter=p<.18?0:p<.46?1:p<.74?2:3;
    const rackSize=base*(narrow?.94:.96);
    // Keep the upright behind the rear-left edge, visible to the left of the bag.
    const rack={x:(narrow?.43:.69)*width+rackSize*(10/440-.20),y:(narrow?.65:.52)*height,size:rackSize,
      opacity:ease(clamp((p-.12)/.08))*(1-ease(clamp((p-.68)/.10))),
      contact:ease(clamp((p-.28)/.02))*(1-ease(clamp((p-.34)/.08)))};
    return {bag,bottle,rack,chapter,detail:clamp(1-Math.abs(p-.34)/.18),join};
  }
  return {pose};
});

